module.exports = __webpack_public_path__ + "img/react-ecommerce4.47e8fb5b.png";